import { render, staticRenderFns } from "./DurationTextField.vue?vue&type=template&id=06f2946e&scoped=true"
import script from "./DurationTextField.vue?vue&type=script&lang=js"
export * from "./DurationTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f2946e",
  null
  
)

export default component.exports